// The counterparty register's URL state: four sorts and seven filters. The mechanics are
// ui/tableUrl.js, shared with every other table.

import { createTableUrl } from '../ui/tableUrl.js';
import { SUBCATEGORIES } from './labels.js';

export const SORTABLE_COLUMNS = [
  { key: 'name', label: 'Name', defaultDirection: 'asc' },
  { key: 'status', label: 'Status', defaultDirection: 'asc' },
  // Best first; the unrated last (TX-US-0040).
  { key: 'rating', label: 'Rating', defaultDirection: 'desc' },
  { key: 'created', label: 'Added', defaultDirection: 'desc' },
];

export const {
  DEFAULT_QUERY,
  defaultDirectionFor,
  fromSearchParams,
  toQueryString,
  nextSort,
  withFilter,
  withCursor,
  toApiSearch,
} = createTableUrl({
  columns: SORTABLE_COLUMNS,
  defaultSort: 'name',
  filters: ['name', 'category', 'subcategory', 'commodity', 'country', 'status', 'rating'],
});

// A change of category keeps the subcategory only when it is one of the new category's own; any
// other is cleared with it, so the register never filters on Storage under Logistics (TX-US-0041).
export function withCategory(query, category) {
  const next = withFilter(query, 'category', category);
  const sameCategory = SUBCATEGORIES.find((s) => s.code === query.subcategory)?.category === category;
  return sameCategory ? next : withFilter(next, 'subcategory', '');
}
